const _menuBtn = $('#js-hamburger')
const _header = $('#js-header')
const _navigation = $('#js-navigation')
const _navigationList = $('.l-navigationSp__list')

//ハンバーガーボタンを押したらナビ開閉
_menuBtn.click(function(){
	$('html').toggleClass('is-fixed')
	_menuBtn.toggleClass('is-open')
	_navigation.toggleClass('is-show')
	_navigationList.toggleClass('is-show')
	_header.toggleClass('is-fixed')
})

//sp時のnavメニューを押した時、navは非表示(ページ内アンカーのため)
$('.js-menu').click(function(){
	$('html').toggleClass('is-fixed')
	_header.toggleClass('is-fixed')
	_navigationList.removeClass('is-show')
	$('#js-navigation').removeClass('is-show')
	$('#js-hamburger').removeClass('is-open')
})


// //メニュー以外の場所を押したらナビが閉じるように
// _navigation.click(function(){
// 	_menuBtn.removeClass('is-open')
// 	_navigation.removeClass('is-show')
// })
